import styled from 'styled-components';
import Box, { BoxProps } from '@material-ui/core/Box';

import { WithMyTheme } from '@keaze/web/theme';
import { NumberOfActiveFilters as CPNumberOfActiveFilters } from '../numberOfActiveFilters';
import { TextField } from '@keaze/web/components/textField';
import { Palette } from '@material-ui/core/styles/createPalette';
import { Colors } from '@keaze/web/theme';

interface TemplateProps extends WithMyTheme {
  $isFocused: boolean;
  $isFilled: boolean;
  $isDisabled: boolean;
}

const hoverStyle = (palette: Palette, colors: Colors) => `
  border-color: transparent;
  // background-color: ${colors.greys.greys16};

  .MuiFilledInput-input {
    color: ${palette.action.hover};
  }

  .MuiInputAdornment-root {
    & > svg {
      fill: ${palette.action.hover};
    }
  }
`;

const isFocusedStyle = (colors: Colors) => `
  // background-color: ${colors.greys.greys16};
`;

const isFilledStyle = (colors: Colors, palette: Palette) => `
  background-color: ${palette.common.white};

  &.MuiFilledInput-root {
    // commented out - SW
    // border-color: ${colors.blues.blues1};

    .MuiInputAdornment-root {
      & > svg {
        fill: ${palette.secondary.main};
      }
    } 
  }
`;

const isDisabledStyle = (colors: Colors, palette: Palette) => `
  cursor: not-allowed;

  &.MuiFilledInput-root {
    border-color: ${colors.greys.greys3};
     background-color: ${palette.common.white};

    .MuiInputBase-input {
      cursor: not-allowed;
      opacity: 0.5;

      &.Mui-disabled {
        cursor: not-allowed;
      }
    }

    .MuiInputAdornment-root {
      & > svg {
        fill: ${colors.greys.greys17};
        opacity: 0.5;
      }
    }
  }

  &:hover {
    &.MuiFilledInput-root {
      background-color: transparent;
    }
  }
`;

export const Field = styled(TextField)``;

export const Template = styled(Box)<TemplateProps & BoxProps>`
  ${({
    theme: {
      palette,
      colors,
      transitions: { easing, duration },
    },
    $isFocused,
    $isFilled,
    $isDisabled,
  }: TemplateProps) => `
    ${Field} {
      .MuiFilledInput-input {
        padding: 7px 0;
        cursor: pointer;
        font-size: 14px !important; 
      }
    }

    .MuiFilledInput-root {
      // commented out - SW
      // border: 1px solid transparent;
      cursor: pointer;
      flex-direction: row-reverse;
      background-color: transparent !important;
  

      .MuiInputAdornment-root svg {
        fill: ${colors.whites.white1};
      }

      &.Mui-focused {
        border-color: transparent;
      }

      &.MuiFilledInput-root,
      .MuiInputBase-input,
      .MuiInputAdornment-root svg {
        transition: ${duration.standard}ms ${easing.easeInOut};
        transition-property: color, fill;
      }

      &:hover {
        ${hoverStyle(palette, colors)}
      }

      ${$isFocused ? isFocusedStyle(colors) : ''};
      ${$isFilled ? isFilledStyle(colors, palette) : ''};
      ${$isDisabled ? isDisabledStyle(colors, palette) : ''};
    }
  `}
`;

export const NumberOfActiveFilters = styled(CPNumberOfActiveFilters)`
  position: absolute;
  top: 50%;
  left: 90px;
  transform: translateY(-50%);
`;
